/**
 * PDP adoption gate: for adopted-title products, confirm display via getPdpAdoption.
 * When the API says shouldDisplay is false and the product is tagged adoptedtitle,
 * replaces the PDP content with an inline unavailable message.
 */

const LOG_PREFIX = '[PDP Adoption Gate]';

function tagsIncludeAdoptedTitle(tags) {
  if (!Array.isArray(tags)) return false;
  return tags.some((t) => String(t).toLowerCase() === 'adoptedtitle');
}

/**
 * @param {HTMLElement} root - .product-information[data-pdp-adoption-gate]
 */
async function runPdpAdoptionGate(root) {
  const overlay = root.querySelector('.pdp-adoption-gate__overlay');
  const handle = root.dataset.productHandle;

  if (!handle) {
    console.warn(LOG_PREFIX, 'Missing data-product-handle');
    showProductContent(root, overlay);
    return;
  }

  try {
    const res = await fetch(
      `/apps/shopifyData/getPdpAdoption?handle=${encodeURIComponent(handle)}`,
      {
        method: 'GET',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      }
    );
    const body = await res.json();
    const data = body && body.success && body.data ? body.data : null;

    if (
      data &&
      data.shouldDisplay === false &&
      tagsIncludeAdoptedTitle(data.product && data.product.tags)
    ) {
      showUnavailable(root, overlay);
      return;
    }
  } catch (e) {
    console.warn(LOG_PREFIX, e);
  }

  showProductContent(root, overlay);
}

function showUnavailable(root, overlay) {
  const content = root.querySelector('[data-pdp-adoption-gate-content]');
  const unavailable = root.querySelector('.pdp-adoption-gate__unavailable');

  if (content) content.hidden = true;
  if (unavailable) unavailable.hidden = false;

  root.classList.add('product-information--adoption-unavailable');
  root.removeAttribute('data-pdp-adoption-gate');
  if (overlay) overlay.remove();
}

function showProductContent(root, overlay) {
  const unavailable = root.querySelector('.pdp-adoption-gate__unavailable');
  const content = root.querySelector('[data-pdp-adoption-gate-content]');

  if (content) content.hidden = false;
  if (unavailable) unavailable.remove();

  root.removeAttribute('data-pdp-adoption-gate');
  if (overlay) overlay.remove();
}

function init() {
  document.querySelectorAll('.product-information[data-pdp-adoption-gate]').forEach((root) => {
    runPdpAdoptionGate(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
